import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AppService } from '@nk/access-block';
import { DestroyRef, inject, Inject, Injectable } from '@angular/core';
import { Observable, switchMap } from 'rxjs';
import { map } from 'rxjs/operators';
import { GENERIC_AUTH_SERVICE_TOKEN, GenericAuthService } from '@nk/auth-lib';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable()
export class AdminGuardService {
  private _destroy = inject(DestroyRef);

  constructor(
    private _appService: AppService,
    @Inject(GENERIC_AUTH_SERVICE_TOKEN) private _authService: GenericAuthService,
  ) {}

  public canActivate(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this._appService.authValidCustomerIsChosen().pipe(
      switchMap(() => {
        return this._appService.identityDataCache.get();
      }),
      map((identity) => {
        return identity.app_user.admin_flag;
      }),
      takeUntilDestroyed(this._destroy),
    );
  }
}
